import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../styles/not-approved-dashboard.css';

class NotApprovedDashboard extends Component {
  render() {
    const { t } = this.context;

    return (
      <div className="not-approved-dashboard col-md-12">
        <div className="not-approved-dashboard__wrapper">
          <h2 className="not-approved-dashboard__wrapper__title">{t('USER_NOT_APPROVED.TITLE')}</h2>
          <p className="not-approved-dashboard__wrapper__paragraph">{t('USER_NOT_APPROVED.FIST_PARAGRAPH')}</p>
          <p className="not-approved-dashboard__wrapper__paragraph">{t('USER_NOT_APPROVED.SECOND_PARAGRAPH')}</p>
          <p className="not-approved-dashboard__wrapper__paragraph">{t('USER_NOT_APPROVED.THIRD_PARAGRAPH')}</p>
          <p className="not-approved-dashboard__wrapper__paragraph">{t('USER_NOT_APPROVED.FOURTH_PARAGRAPH')}</p>
          <p className="not-approved-dashboard__wrapper__paragraph">
            {t('USER_NOT_APPROVED.FIFTH_PARAGRAPH')}
            <a href="mailto:affiliates@naga.com">affiliates@naga.com</a>
          </p>     
        </div>
      </div>
    )
  }
}

NotApprovedDashboard.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default NotApprovedDashboard;


// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/not-approved-dashboard.js